import React from "react";
import { Link } from "react-router-dom";

function FooterCourses() {
  return (
    <div className="col-md-6 mb-5">
      <h5 className="text-primary text-uppercase mb-4" style={{ letterSpacing: "5px" }}>Algunos cursos</h5>
      <div className="d-flex flex-column justify-content-start">
        <Link to={`/tech/course-details/1`}  className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2"></i>Aprende programación de software en sólo 4 semanas</Link>
        <Link to={`/002/course-details/3`}  className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2"></i>Importación Segura para Principiantes con 1688</Link>
        <Link to={`/tech/course-details/5`}  className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2"></i>El poder de liderar desde adentro</Link>
        <Link to={`/tech/course-details-ws/12`}  className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2"></i>Estrategia de cierre de ventas por whatsApp</Link>
        <Link to={`001/course-details/4`}  className="text-white mb-2" href="#"><i className="fa fa-angle-right mr-2"></i>Importación con Alibaba, AliExpress y Temu</Link>
      </div>
    </div>
  );
}

export default FooterCourses;